const BuildProductionEnum = {
  DEV: "DEV",
  TEST: "TEST",
  PRODUCTION: "PRODUCTION",
};
export const getBaseURL = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return "http://10.10.100.5:8898";
    case BuildProductionEnum.TEST:
      return "http://10.10.100.5:8899";
    case BuildProductionEnum.PRODUCTION:
      return "https://api.domecare-pharma.com";
    default:
      return "https://api.domecare-pharma.com";
  }
};

export const getImageBaseUrl = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return "http://10.10.100.5:7781";
    case BuildProductionEnum.TEST:
      return "http://10.10.100.5:7781";
    case BuildProductionEnum.PRODUCTION:
      return "https://files.dome-care.com";
    default:
      return "https://files.dome-care.com";
  }
};
export const getGoogleMapsAPIKey = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return "AIzaSyDGRRkFBDlfHl1Jz_osuTC8mSpkArlXu_o";
    case BuildProductionEnum.TEST:
      return "AIzaSyDGRRkFBDlfHl1Jz_osuTC8mSpkArlXu_o";
    case BuildProductionEnum.PRODUCTION:
      return "AIzaSyDGRRkFBDlfHl1Jz_osuTC8mSpkArlXu_o";
    default:
      return "AIzaSyDGRRkFBDlfHl1Jz_osuTC8mSpkArlXu_o";
  }
};
export const getGooglePlayStoreAppLink = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return "https://play.google.com/store/apps/details?id=com.Ayat.DomeCarePhamra&pcampaignid=web_share";
    case BuildProductionEnum.TEST:
      return "https://play.google.com/store/apps/details?id=com.Ayat.DomeCarePhamra&pcampaignid=web_share";
    case BuildProductionEnum.PRODUCTION:
      return "https://play.google.com/store/apps/details?id=com.Ayat.DomeCarePhamra&pcampaignid=web_share";
    default:
      return "https://play.google.com/store/apps/details?id=com.Ayat.DomeCarePhamra&pcampaignid=web_share";
  }
};
export const getAppleAppStoreAppLink = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return "https://apps.apple.com/ae/app/domecare-pharma/id6742398571";
    case BuildProductionEnum.TEST:
      return "https://apps.apple.com/ae/app/domecare-pharma/id6742398571";
    case BuildProductionEnum.PRODUCTION:
      return "https://apps.apple.com/ae/app/domecare-pharma/id6742398571";
    default:
      return "https://apps.apple.com/ae/app/domecare-pharma/id6742398571";
  }
};

export const getDefaultLatitude = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return 25.197525;
    case BuildProductionEnum.TEST:
      return 25.197525;
    case BuildProductionEnum.PRODUCTION:
      return 25.197525;
    default:
      return 25.197525;
  }
};
export const getDefaultLongtude = (env: string) => {
  switch (env) {
    case BuildProductionEnum.DEV:
      return 55.274288;
    case BuildProductionEnum.TEST:
      return 55.274288;
    case BuildProductionEnum.PRODUCTION:
      return 55.274288;
    default:
      return 55.274288;
  }
};
